import { mapEnumToOptions } from '@abp/ng.core';

export enum ProviderEnum {
  AWS = 1,
  Eclit = 2,
  Azure = 3,
  Huawei = 4,
  OracleProd = 5,
  OraclePreProd = 6
}

export const ProviderEnumOptions = mapEnumToOptions(ProviderEnum).sort((a, b) => a.key.localeCompare(b.key));
